import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "lib/utils"

// Variants extended beyond shadcn default to mirror MUI Chip `color` values:
// success / warning / info — soft tinted (10% bg + 40% border + foreground)
// so the badges read as informational pills rather than primary CTAs.
const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-destructive/40 bg-destructive/10 text-destructive",
        info:
          "border-brand-purple1/40 bg-brand-purple1/10 text-brand-purple1",
        warning:
          "border-warning/40 bg-warning/10 text-warning",
        success:
          "border-success/40 bg-success/10 text-success",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
